<template>
  <b-modal
    hide-header
    hide-footer
    :no-fade="standalone"
    @hide="hide"
    ref="artworkModal"
  >
    <div class="modal-container" @click="close" v-if="artwork">
      <div class="description">
        <div class="modal-content" @click.stop>
          <artwork-description :artwork="artwork"> </artwork-description>
        </div>
      </div>
      <div class="content" ref="content">
        <header class="modal-header">
          <button type="button" aria-label="Close" class="close" @click="close">
            ×
          </button>
        </header>
        <div class="modal-content" @click.stop>
          <artwork-content :artwork="artwork"> </artwork-content>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Vue from "vue";
import ArtworkContent from "./ArtworkContent";
import ArtworkDescription from "./ArtworkDescription";
import ArtworkComponent from "./Artwork";
import { Artwork } from "../models";

export default Vue.component("artwork-modal", {
  components: {
    ArtworkContent,
    ArtworkDescription,
    artwork: ArtworkComponent
  },
  props: ["parent", "initialArtwork"],
  data() {
    return {
      user: window.user,
      history: [this.parent],
      artwork: this.initialArtwork,
      artworks: null
    };
  },
  computed: {
    standalone() {
      const { route } = this.$router.resolve(this.history[0]);
      return route.name === "artwork";
    }
  },
  watch: {
    "$route.params.artwork": {
      async handler(id) {
        if (!id) {
          return;
        }

        if (this.initialArtwork) {
          return;
        }

        if (this.$refs.content) {
          this.$refs.content.scrollTop = 0;
        }

        this.history.push(this.$route.path);
        if (this.$refs.artworkModal) {
          this.$refs.artworkModal.hide("loading");
          document.body.classList.add("loading-open");
        }
        this.artwork = await new Artwork({ id }).load();
        document.body.classList.remove("loading-open");
        this.$refs.artworkModal.show();
      },
      immediate: true
    },
    async "artwork.author.id"(id) {
      if (!id) {
        return;
      }

      this.artworks = await new Artwork().byUser(id);
    }
  },
  methods: {
    open() {
      this.$refs.artworkModal.show();
    },
    close() {
      this.$refs.artworkModal.hide();
    },
    hide({ trigger }) {
      if (trigger === "loading") {
        return;
      }

      if (this.initialArtwork) {
        return;
      }

      if (this.standalone) {
        this.$router.push({ name: "home" });
        return;
      }

      this.$router.go(-this.history.length + 1);
    }
  }
});
</script>

<style lang="scss" scoped>
$grid-gutter-width: 10px;
@import "~bootstrap/scss/bootstrap-grid.scss";

.modal-dialog {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0;
  max-width: 100%;

  > .modal-content {
    background-color: transparent;
    border: 0;

    > .modal-body {
      padding: 0;

      .modal-container {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        @include media-breakpoint-up(lg) {
          flex-direction: row;
        }

        .description {
          display: none;

          @include media-breakpoint-up(lg) {
            display: block;
            flex-basis: 253px;
            padding: 28px 0;
            margin-right: 5px;
          }

          hr {
            margin: 16px -20px;
          }

          .tag {
            color: black;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            &:hover {
              border-color: black;
            }
          }
        }

        .content {
          overflow: auto;

          @include media-breakpoint-up(lg) {
            flex-basis: calc(85vw - 131px);
            padding: 28px 0;
            margin-left: 5px;
          }

          .modal-header {
            position: fixed;
            right: 0;
            border: 0;
            z-index: 1050;

            @include media-breakpoint-up(lg) {
              right: calc(15vw - 130px);
            }
          }

          .modal-content {
            @include media-breakpoint-up(lg) {
              width: 70vw;
              max-width: 1400px;
            }
            > article {
              border-top-left-radius: inherit;
              border-top-right-radius: inherit;
              > div {
                border-radius: inherit;
                p:first-child .img-fluid:not(.img-percent):first-child {
                  border-top-left-radius: 0.3rem;
                  border-top-right-radius: 0.3rem;
                }
              }
            }

            article {
              > div {
                padding: 0 40px;
              }

              hr {
                width: 80%;
              }

              iframe {
                max-width: 100%;
                border: none;
              }

              .no-padding {
                max-width: calc(100% + 80px) !important;
                margin: 0 -40px !important;
              }

              .img-percent {
                display: block;
                margin: 0 auto !important;

                @media only screen and (max-width: 900px) {
                  width: 900px !important;
                }
              }
            }

            .status {
              background-color: black;
            }

            .author {
              background-color: #1f1f1f;
              border-bottom-left-radius: inherit;
              border-bottom-right-radius: inherit;

              .card-container {
                overflow: hidden;
                margin-bottom: 50px;

                @media (min-width: 512px) {
                  max-height: 544px;
                }

                .card {
                  margin: 7.5px;
                  max-width: calc(50% - 15px);

                  &.d-card {
                    display: none;

                    @media (min-width: 512px) {
                      display: block;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

.cc svg,
.social img {
  width: 26px;
  height: 26px;
  margin: 0 5px;
}
</style>
